import { render, staticRenderFns } from "./class-list.vue?vue&type=template&id=52b89e0e&scoped=true&"
import script from "./class-list.vue?vue&type=script&lang=js&"
export * from "./class-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b89e0e",
  null
  
)

export default component.exports